<template>
    <checkoutHeader />
    <slot></slot>
    <checkoutFooter />
</template>

<script>
    import checkoutHeader from "@/views/checkout/_header.vue";
    import checkoutFooter from "@/views/checkout/_footer.vue";

    export default {
        name: 'Checkout',
        components: {
            checkoutHeader,
            checkoutFooter
        },
    }
</script>

